import { Routes, Route } from "react-router-dom";
import Form from "./Form";
import List from "./List";
export const MODEL = "client";
export const BASE_PATH = "/suppliers";
export const TITLE = ["Supplier", "Suppliers"];
export default function Entity(props: any) {
  return (
    <Routes>
      <Route path={`/form`} element={<Form />} />
      <Route path={`/`} element={<List />} />
    </Routes>
  );
}
